// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MjgtS","col":"styles_col__3QeSJ","actions":"styles_actions__1GwEq","conflict":"styles_conflict__c5Tv6"};